import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant, LangConstant, SystemConstant } from "const";
import { useMutation } from "react-query";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";

export default function useCreateDepartmentChannel() {
  const { t: getLabel } = useTranslation();

  const createDepartmentChannelMutation = useMutation({
    mutationFn: async payload => {
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.POST_CREATE_DEPARTMENT_CHANNEL,
        qs.stringify(HumpUtils.decamelizeKeys(payload)),
      );
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onClose }) => {
      if (response.status === ApiConstant.STT_OK) {
        await ApiUtils.apiCreateUserActivitiesLog(SystemConstant.LOGGER_ACTION_TYPES.CREATE_DEPARTMENT_CHANNEL);
        SystemUtils.appendNotification(getLabel("TXT_CREATE_CHANNEL_SUCCESS"), "success");
        onClose();
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.DEPARTMENT_ERROR.DUPLICATED
      ) {
        SystemUtils.appendNotification(getLabel("TXT_CHANNEL_DUPLICATED"), "error");
      } else {
        SystemUtils.appendNotification(getLabel("TXT_CREATE_CHANNEL_FAIL"), "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const createDepartmentChannel = payload => {
    createDepartmentChannelMutation.mutate(payload);
  };

  return { createDepartmentChannel };
}
